/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LocalizedCaseUrl
 */
export interface LocalizedCaseUrl {
	/**
	 *
	 * @type {string}
	 * @memberof LocalizedCaseUrl
	 */
	twoLetterLangCode?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof LocalizedCaseUrl
	 */
	twoLetterFlagCountryCode?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof LocalizedCaseUrl
	 */
	url?: string | null;
}

/**
 * Check if a given object implements the LocalizedCaseUrl interface.
 */
export function instanceOfLocalizedCaseUrl(value: object): value is LocalizedCaseUrl {
	return true;
}

export function LocalizedCaseUrlFromJSON(json: any): LocalizedCaseUrl {
	return LocalizedCaseUrlFromJSONTyped(json, false);
}

export function LocalizedCaseUrlFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): LocalizedCaseUrl {
	if (json == null) {
		return json;
	}
	return {
		twoLetterLangCode: json['twoLetterLangCode'] == null ? undefined : json['twoLetterLangCode'],
		twoLetterFlagCountryCode:
			json['twoLetterFlagCountryCode'] == null ? undefined : json['twoLetterFlagCountryCode'],
		url: json['url'] == null ? undefined : json['url'],
	};
}

export function LocalizedCaseUrlToJSON(json: any): LocalizedCaseUrl {
	return LocalizedCaseUrlToJSONTyped(json, false);
}

export function LocalizedCaseUrlToJSONTyped(
	value?: LocalizedCaseUrl | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		twoLetterLangCode: value['twoLetterLangCode'],
		twoLetterFlagCountryCode: value['twoLetterFlagCountryCode'],
		url: value['url'],
	};
}
